<div class="main-d dashboard permision sys-app-details">
    <router-outlet></router-outlet>
</div>